import { APP_CONFIG } from '../constants/global-variables.js';
export async function getJackPotValue() {


    const url = `${APP_CONFIG.URL.apiBasePath}ajax/jackpotvalue`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}

export async function getAdminUsers() {

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/adminusers`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });

        return res.data;
    } catch (err) {

    }
}

export async function jackpotTransfer(userId, typeId) {

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/jackpottransfer`;

    try {
        const res = await axios.post(url, {
            user_id: userId,
            type_id: typeId
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });

        return res.data;
    } catch (err) {

    }
}

export async function lastJackpotWinner() {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/lastjackpotwinner`;

    try {
        const res = await axios.post(url, {
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });

        return res.data.data;
    } catch (err) {
        console.log(err);

    }
}